module.exports = __webpack_public_path__ + "static/img/shipinhuiyi.456a094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/shipinhuiyi.png
// module id = HRVf
// module chunks = 24